import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Tooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import constants from "./../../../constants";
import MessageDot from "components/MessageDot";
import userDefaultImage from "assets/images/staff-default.svg";
import { Logout } from "repositories/user-repository";
import { canAccessAiAssistantChat, setStorage } from "utils";
import { clearOfficeNavigationContext } from "utils/officeNavigationContext";
import Separator from "assets/images/Separator.svg";
import Loader from "components/Loader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { deletedUserDataGetForSendbird } from "Messenger/hooks/conversation/useConversation";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import IsAccessibleChatAssitant from "aiAssitant/ChatAssistant";
import { useAppContext } from "context/AppContext";
import { clearLogoutSessionFlags } from "utils/appLogout";
const HeaderDropdown = (props) => {
  const { t, newNotification, isDisabledClass, redirectWithCheck, location } =
    props;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { setIsAdminModalOpen, isStaff, isOwner, ownerList } =
    useAccountOwnerCommon();
  const [dropdownNotificationOpen, setDropdownNotificationOpen] =
    useState(false);
  const [dropdownAiChatOpen, setDropdownAiChatOpen] = useState(false);
  const history = useHistory();
  const [tooltipState, setTooltipState] = useState({
    dashboard_tooltip: false,
    my_offices_header_tooltip: false,
    task_management_header_tooltip: false,
    team_chat_header_tooltip: false,
    notes_header_tooltip: false,
    schedular_header_tooltip: false,
    patient_live_chat_header_tooltip: false,
    appointment_header_tooltip: false,
    switch_owner_header_tooltip: false,
    ai_chat_header_tooltip: false,
    global_directory_header_tooltip: false,
  });

  const toggleTooltip = (id) => {
    setTooltipState((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleRestData = () => {
    clearOfficeNavigationContext();
  };

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const toggleNotificafation = () =>
    setDropdownNotificationOpen((prevState) => !prevState);
  const { logout: msalLogout } = useAppContext();
  const logout = async () => {
    try {
      setIsLoading(true);
      const cacheKeysToPreserve = [
        constants.manageDashboardList.cache.requestApprovalCache,
        constants.manageDashboardList.cache.dashboardChatCache,
        constants.notes.cache.Noteslisting,
        constants.tasks.cache.taskslisting,
        constants.manageDashboardList.cache.dashboardTeamChatCache,
      ];

      let res = await Logout();
      if (res?.status) {
        if (deletedUserDataGetForSendbird().length) {
          const dbs = await indexedDB.databases();
          dbs.forEach((db) => {
            if (db.name.includes("sendbird")) {
              indexedDB.deleteDatabase(db.name);
            }
          });
        }

        const logoutPromise = msalLogout({
          sessionCacheKeysToPreserve: cacheKeysToPreserve,
        });
        if (logoutPromise && typeof logoutPromise.then === "function") {
          await logoutPromise;
        }
      }
    } catch (error) {
      console.error("Logout error:", error);
      clearLogoutSessionFlags();
    } finally {
      setIsLoading(false);
    }
  };

  const {
    role,
    profileSetupStep,
    userSubscription,
    isAdmin,
    isMessenger,
    isDoctor,
    isPatientChat,
  } = props.profile;
  let dropdownItems = null;
  const { accountOwnerCheck, staffCheck, superAdminCheck, patientCheck } =
    useMemo(
      () => ({
        staffCheck: isStaff,
        accountOwnerCheck: isOwner,
        superAdminCheck: role?.systemRole === constants.systemRoles.superAdmin,
        patientCheck: role?.systemRole === constants.systemRoles.patient,
      }),
      [role?.systemRole, isStaff, isOwner],
    );
  if (accountOwnerCheck) {
    dropdownItems = (
      <AccountOwnerDropdownItems
        profileSetupStep={profileSetupStep}
        subscription={userSubscription}
        t={t}
        isDisabledClass={isDisabledClass}
        redirectWithCheck={redirectWithCheck}
        location={location}
        accountOwnerCheck={accountOwnerCheck}
        staffCheck={staffCheck}
        userProfileData={props?.profile}
        dropdownAiChatOpen={dropdownAiChatOpen}
        setDropdownAiChatOpen={setDropdownAiChatOpen}
        toggle={toggle}
        newNotification={newNotification}
      />
    );
  } else if (superAdminCheck) {
    dropdownItems = <SuperAdminDropdownItems t={t} />;
  } else if (staffCheck) {
    dropdownItems = (
      <StaffDropdownItems
        t={t}
        profile={props.profile}
        ownerList={ownerList}
        isDisabledClass={isDisabledClass}
        redirectWithCheck={redirectWithCheck}
        location={location}
        accountOwnerCheck={accountOwnerCheck}
        staffCheck={staffCheck}
        userProfileData={props?.profile}
        dropdownAiChatOpen={dropdownAiChatOpen}
        setDropdownAiChatOpen={setDropdownAiChatOpen}
        toggle={toggle}
        setIsAdminModalOpen={setIsAdminModalOpen}
        newNotification={newNotification}
      />
    );
  } else if (patientCheck) {
    dropdownItems = <PatientDropdownItems t={t} profile={props.profile} />;
  }

  let showNotificationIcon = true;
  if (staffCheck && !ownerList?.length) {
    showNotificationIcon = false;
  }

  const addDefaultSrc = (ev) => {
    ev.target.src = userDefaultImage;
    ev.target.onerror = null;
  };
  const accountOwnerSubscrption = useMemo(
    () =>
      profileSetupStep === "completed" &&
      userSubscription &&
      userSubscription.packageType !== constants.packageTypes.free,
    [profileSetupStep, userSubscription],
  );
  const { staffIsAdminCanAccess } = useMemo(
    () => ({
      staffIsAdminCanAccess: staffCheck && ownerList?.length > 0,
    }),
    [staffCheck, isAdmin, ownerList],
  );
  const accountOwnerCanAccess = useMemo(
    () => accountOwnerCheck && accountOwnerSubscrption,
    [accountOwnerCheck && accountOwnerSubscrption],
  );
  //Onwer with subscription and staff with owner check (staffIsAdminAndAccountOwnerAccess)
  const staffIsAdminAndAccountOwnerAccess =
    staffIsAdminCanAccess || accountOwnerCanAccess;

  //Onwer with subscription and only staff check (staffAndAccountOwnerAccess)
  const staffAndAccountOwnerAccess = staffCheck || accountOwnerCanAccess;

  const adminStaffTeamChatCheck =
    (staffCheck && !!isMessenger) || accountOwnerCanAccess;
  const adminStaffPatientChatCheck =
    (staffCheck && !!isPatientChat) || accountOwnerCanAccess;

  return (
    <>
      {isLoading && <Loader />}
      {(staffIsAdminAndAccountOwnerAccess || staffAndAccountOwnerAccess) && (
        <>
          <div className="header_icons_placement">
            {staffIsAdminAndAccountOwnerAccess && (
              <>
                <Dropdown
                  isOpen={dropdownNotificationOpen}
                  toggle={toggleNotificafation}
                  className="dashboard-home-redirection-icon"
                  id="dashboard_tooltip"
                >
                  <DropdownToggle caret={false} tag="div">
                    <Link
                      to={constants.routes.dashboard.managerDashboard}
                      onClick={() => handleRestData()}
                    >
                      <img
                        src={
                          require("assets/images/space_dashboard.svg").default
                        }
                        alt="icon"
                        className="header_icon_width"
                      />
                    </Link>
                  </DropdownToggle>
                </Dropdown>
                <Tooltip
                  isOpen={tooltipState.dashboard_tooltip}
                  placement="top"
                  target="dashboard_tooltip"
                  toggle={() => toggleTooltip("dashboard_tooltip")}
                >
                  {t("dashBoard.managerDashBoard")}
                </Tooltip>
              </>
            )}
            {staffAndAccountOwnerAccess && (
              <>
                <Dropdown
                  isOpen={dropdownNotificationOpen}
                  toggle={toggleNotificafation}
                  className="dashboard-home-redirection-icon"
                  id="my_offices_header_tooltip"
                >
                  <DropdownToggle caret={false} tag="div">
                    <Link
                      to={
                        staffCheck
                          ? constants.routes.staff.offices
                          : constants.routes.accountOwner.offices
                      }
                      onClick={() => handleRestData()}
                    >
                      <img
                        src={
                          require("assets/images/my_offices_header_icon.svg")
                            .default
                        }
                        alt="icon"
                      />
                    </Link>
                  </DropdownToggle>
                </Dropdown>

                <Tooltip
                  isOpen={tooltipState.my_offices_header_tooltip}
                  placement="top"
                  target="my_offices_header_tooltip"
                  toggle={() => toggleTooltip("my_offices_header_tooltip")}
                >
                  {t("navbar.MyOffices")}
                </Tooltip>
              </>
            )}
          </div>
          {(showNotificationIcon || staffAndAccountOwnerAccess) && (
            <img
              src={Separator}
              alt="separator"
              className="separator_property hide_on_mobile"
            />
          )}
        </>
      )}
      {/* {(staffCheck ||
        accountOwnerCanAccess ||
        staffCanAccessWithoutAdminPermission) && ( */}
      {/* <> */}
      <div className="header_icons_placement hide_on_mobile">
        {(staffIsAdminCanAccess || accountOwnerCanAccess) && (
          <>
            <Dropdown
              isOpen={dropdownNotificationOpen}
              toggle={toggleNotificafation}
              className="dashboard-home-redirection-icon"
              id="task_management_header_tooltip"
            >
              <DropdownToggle caret={false} tag="div">
                <img
                  src={
                    require("assets/images/task_management_header_icon.svg")
                      .default
                  }
                  alt="icon"
                  className="header_icon_width hide_on_mobile"
                  onClick={() => {
                    redirectWithCheck(
                      {
                        pathname:
                          constants.routes.taskManagements.taskManagement,
                        state: location?.state,
                      },
                      !!isDisabledClass.taskManagement,
                    );
                    clearOfficeNavigationContext();
                  }}
                />
              </DropdownToggle>
            </Dropdown>

            <Tooltip
              isOpen={tooltipState.task_management_header_tooltip}
              placement="top"
              target="task_management_header_tooltip"
              toggle={() => toggleTooltip("task_management_header_tooltip")}
            >
              {t("navbar.taskManagement")}
            </Tooltip>
          </>
        )}
        {(staffIsAdminCanAccess || accountOwnerCanAccess) && (
          <>
            <Dropdown
              isOpen={dropdownNotificationOpen}
              toggle={toggleNotificafation}
              className="dashboard-home-redirection-icon"
              id="global_directory_header_tooltip"
            >
              <DropdownToggle caret={false} tag="div">
                <img
                  src={
                    require("assets/images/global_directory_icon.svg").default
                  }
                  alt="icon"
                  className="header_icon_width hide_on_mobile"
                  onClick={() => {
                    redirectWithCheck({
                      pathname:
                        constants.routes.accountOwner
                          .globalOfficeStaffInformation,
                    });
                  }}
                />
              </DropdownToggle>
            </Dropdown>

            <Tooltip
              isOpen={tooltipState.global_directory_header_tooltip}
              placement="top"
              target="global_directory_header_tooltip"
              toggle={() => toggleTooltip("global_directory_header_tooltip")}
            >
              {t("navbar.companyDirectory")}
            </Tooltip>
          </>
        )}
        {adminStaffTeamChatCheck && (
          <>
            <Dropdown
              isOpen={dropdownNotificationOpen}
              toggle={toggleNotificafation}
              className="dashboard-home-redirection-icon"
              id="team_chat_header_tooltip"
            >
              <DropdownToggle caret={false} tag="div">
                <img
                  src={
                    require("assets/images/team_chat_header_icon.svg").default
                  }
                  alt="icon"
                  className="header_icon_width hide_on_mobile"
                  onClick={() => {
                    redirectWithCheck(
                      {
                        pathname: constants.routes.chatModule,
                        state: location?.state,
                      },
                      !!isDisabledClass.liveChat,
                    );
                    setStorage("isChatFromDashBoard", false);
                    clearOfficeNavigationContext();
                  }}
                />
              </DropdownToggle>
            </Dropdown>

            <Tooltip
              isOpen={tooltipState.team_chat_header_tooltip}
              placement="top"
              target="team_chat_header_tooltip"
              toggle={() => toggleTooltip("team_chat_header_tooltip")}
            >
              {t("dashBoard.teamChat")}
            </Tooltip>
          </>
        )}
        {staffAndAccountOwnerAccess && (
          <>
            <Dropdown
              isOpen={dropdownNotificationOpen}
              toggle={toggleNotificafation}
              className="dashboard-home-redirection-icon"
              id="notes_header_tooltip"
            >
              <DropdownToggle caret={false} tag="div">
                <img
                  src={require("assets/images/notes_header_icon.svg").default}
                  alt="icon"
                  className={
                    "header_icon_width hide_on_mobile" +
                    (staffIsAdminCanAccess || !ownerList?.length
                      ? " me-sm"
                      : "")
                  }
                  onClick={() => {
                    redirectWithCheck(
                      {
                        pathname: constants.routes.notes,
                        state: location?.state,
                      },
                      !!isDisabledClass.notesAndReminder,
                    );
                    clearOfficeNavigationContext();
                    setStorage("isChatFromDashBoard", false);
                  }}
                />
              </DropdownToggle>
            </Dropdown>

            <Tooltip
              isOpen={tooltipState.notes_header_tooltip}
              placement="top"
              target="notes_header_tooltip"
              toggle={() => toggleTooltip("notes_header_tooltip")}
            >
              {t("notes.note")}
            </Tooltip>
          </>
        )}
      </div>
      {showNotificationIcon && (
        <img
          src={Separator}
          alt="separator"
          className="separator_property hide_on_mobile"
        />
      )}
      {/* </> */}
      {/* )} */}

      {staffIsAdminCanAccess && (
        <>
          <Dropdown
            isOpen={dropdownNotificationOpen}
            toggle={toggleNotificafation}
            className="dashboard-home-redirection-icon"
            id="switch_owner_header_tooltip"
          >
            <DropdownToggle caret={false} tag="div">
              <img
                src={require("assets/images/switch_owner.svg").default}
                alt="icon"
                onClick={() => {
                  setIsAdminModalOpen((prev) => !prev);
                }}
                className="header_icon_width hide_on_mobile"
              />
            </DropdownToggle>
          </Dropdown>

          <Tooltip
            isOpen={tooltipState.switch_owner_header_tooltip}
            placement="top"
            target="switch_owner_header_tooltip"
            toggle={() => toggleTooltip("switch_owner_header_tooltip")}
          >
            {t("staff.switchAccountOwner")}
          </Tooltip>

          {showNotificationIcon && (
            <img
              src={Separator}
              alt="separator"
              className="separator_property hide_on_mobile"
            />
          )}
        </>
      )}
      {(staffIsAdminCanAccess || accountOwnerCanAccess) && (
        <>
          <Dropdown
            isOpen={dropdownNotificationOpen}
            toggle={toggleNotificafation}
            className="dashboard-home-redirection-icon"
            id="schedular_header_tooltip"
          >
            <DropdownToggle caret={false} tag="div">
              <img
                src={require("assets/images/schedular_header_icon.svg").default}
                alt="icon"
                onClick={() => {
                  redirectWithCheck(
                    {
                      pathname: "/scheduler",
                      state: location?.state,
                    },
                    !!isDisabledClass.scheduler,
                  );
                  setStorage("IsFromLeaveSchedule", {
                    isFromleaveConflict: false,
                  });
                  setStorage("isChatFromDashBoard", false);
                  clearOfficeNavigationContext();
                }}
                className="header_icon_width hide_on_mobile"
              />
            </DropdownToggle>
          </Dropdown>

          <Tooltip
            isOpen={tooltipState.schedular_header_tooltip}
            placement="top"
            target="schedular_header_tooltip"
            toggle={() => toggleTooltip("schedular_header_tooltip")}
          >
            {t("navbar.scheduler")}
          </Tooltip>

          {showNotificationIcon && (
            <img
              src={Separator}
              alt="separator"
              className="separator_property hide_on_mobile"
            />
          )}
        </>
      )}
      {(adminStaffPatientChatCheck ||
        patientCheck ||
        (staffIsAdminCanAccess && isDoctor) ||
        accountOwnerCanAccess) && (
        <>
          <div className="header_icons_placement hide_on_mobile">
            {(adminStaffPatientChatCheck || patientCheck) && (
              <>
                <Dropdown
                  isOpen={dropdownNotificationOpen}
                  toggle={toggleNotificafation}
                  className={"dashboard-home-redirection-icon"}
                  id="patient_live_chat_header_tooltip"
                >
                  <DropdownToggle caret={false} tag="div">
                    <img
                      src={
                        require("assets/images/patient_live_chat_header_icon.svg")
                          .default
                      }
                      alt="icon"
                      onClick={() => {
                        if (patientCheck) {
                          history.push({
                            pathname:
                              constants.routes
                                .patientWithOwnerOrDoctorChatModule,
                            state: location?.state,
                          });
                        } else {
                          redirectWithCheck(
                            {
                              pathname: constants.routes.patientChatModule,
                              state: location?.state,
                            },
                            !!isDisabledClass.patientConversation,
                          );
                        }
                        setStorage("isChatFromDashBoard", false);
                      }}
                      className={
                        "header_icon_width hide_on_mobile" +
                        (patientCheck ? " me-xs" : "")
                      }
                    />
                  </DropdownToggle>
                </Dropdown>

                <Tooltip
                  isOpen={tooltipState.patient_live_chat_header_tooltip}
                  placement="top"
                  target="patient_live_chat_header_tooltip"
                  toggle={() =>
                    toggleTooltip("patient_live_chat_header_tooltip")
                  }
                >
                  {t(
                    patientCheck
                      ? "navbar.doctorChat"
                      : "messenger.patientLiveChat",
                  )}
                </Tooltip>
              </>
            )}
            {((staffCheck && isDoctor) || accountOwnerCanAccess) && (
              <>
                <Dropdown
                  isOpen={dropdownNotificationOpen}
                  toggle={toggleNotificafation}
                  className="dashboard-home-redirection-icon"
                  id="appointment_header_tooltip"
                >
                  <DropdownToggle caret={false} tag="div">
                    <img
                      src={
                        require("assets/images/appointment_header_icon.svg")
                          .default
                      }
                      alt="icon"
                      className="header_icon_width hide_on_mobile"
                      onClick={() => {
                        redirectWithCheck(
                          {
                            pathname:
                              constants.routes.appointment.appointmentScreen,
                            state: location?.state,
                          },
                          !!isDisabledClass.patientAppointment,
                        );
                        setStorage("officeState", {
                          officeState: { isfromPaitentDetail: true },
                        });
                        clearOfficeNavigationContext();
                      }}
                    />
                  </DropdownToggle>
                </Dropdown>

                <Tooltip
                  isOpen={tooltipState.appointment_header_tooltip}
                  placement="top"
                  target="appointment_header_tooltip"
                  toggle={() => toggleTooltip("appointment_header_tooltip")}
                >
                  {t("appointments")}
                </Tooltip>
              </>
            )}
          </div>
          {showNotificationIcon && (isStaff || isOwner) && (
            <img
              src={Separator}
              alt="separator"
              className="separator_property "
            />
          )}
        </>
      )}

      {props?.profile?.showWebAiToggleInHeader && (
        <IsAccessibleChatAssitant>
          <Dropdown
            isOpen={dropdownAiChatOpen}
            toggle={() => {}}
            className="notify-dropdown p-0"
            id="ai_chat_header_tooltip"
          >
            <DropdownToggle caret={false} tag="div">
              <img
                src={require("assets/images/ai-chat-icon.svg").default}
                alt="icon"
                className="min_width_25"
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownAiChatOpen((prev) => !prev);
                }}
              />
              {dropdownAiChatOpen && (
                <div className="text-left" onClick={(e) => e.stopPropagation()}>
                  <IsAccessibleChatAssitant
                    dropdownAiChatOpen={dropdownAiChatOpen}
                    setDropdownAiChatOpen={setDropdownAiChatOpen}
                  />
                </div>
              )}
            </DropdownToggle>
          </Dropdown>
          <Tooltip
            isOpen={tooltipState.ai_chat_header_tooltip}
            placement="top"
            target="ai_chat_header_tooltip"
            toggle={() => toggleTooltip("ai_chat_header_tooltip")}
          >
            {t("aiAssistant.aiAssist")}
          </Tooltip>
        </IsAccessibleChatAssitant>
      )}

      {(staffCheck || accountOwnerCanAccess) && showNotificationIcon && (
        <Dropdown
          isOpen={dropdownNotificationOpen}
          toggle={toggleNotificafation}
          className="notify-dropdown p-0"
        >
          <DropdownToggle caret={false} tag="div">
            <Link to={constants.routes.notification.notificationDetail}>
              {newNotification ? (
                <img
                  src={require("assets/images/Notification.svg").default}
                  alt="iconaaa"
                  className="min_width_30 abc"
                />
              ) : (
                <img
                  src={
                    require("assets/images/notification-bell-icon.svg").default
                  }
                  alt="icon"
                  className="min_width_30"
                />
              )}
            </Link>
          </DropdownToggle>
        </Dropdown>
      )}

      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle caret={false} className="user-dropdown" tag="div">
          <div className="usr-info">
            <div className="media">
              {props?.profile?.profilePic ? (
                <img
                  className="user-img"
                  src={props?.profile?.profilePic}
                  onError={addDefaultSrc}
                  alt="caret"
                />
              ) : (
                <img
                  className="user-img"
                  src={require("assets/images/staff-default.svg").default}
                  alt="usr"
                />
              )}
              <div className="responsive-dot-container">
                <MessageDot />
              </div>
              <div className="media-body align-self-center d-none d-md-block">
                <span>
                  {role.systemRole === constants.systemRoles.superAdmin
                    ? `${props.profile.firstName} ${props.profile.lastName}`
                    : props.profile.firstName}
                </span>
                <MessageDot />
                <img
                  src={require("assets/images/caret.svg").default}
                  alt="caret"
                />
              </div>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu end>
          {dropdownItems}
          <div className="dropdown-group logout_button_style">
            <DropdownItem onClick={logout}>
              <span className="menu-hover-effect">{t("navbar.logout")}</span>
            </DropdownItem>
          </div>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

function AccountOwnerDropdownItems({
  profileSetupStep,
  subscription,
  t,
  isDisabledClass,
  redirectWithCheck,
  location,
  accountOwnerCheck,
  staffCheck,
  userProfileData,
  dropdownAiChatOpen,
  setDropdownAiChatOpen,
  toggle,
}) {
  if (
    profileSetupStep === "packageExpired" ||
    profileSetupStep === "subscriptionTerminated" ||
    !subscription
  ) {
    return (
      <>
        <DropdownItem>
          <Link
            to={{
              pathname: constants.routes.addSubscription,
              state: { choosePlan: true },
            }}
          >
            <span className="menu-hover-effect">
              {t("navbar.chooseSubscription")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.help}>
            <span className="menu-hover-effect">{t("navbar.help")}</span>
          </Link>
        </DropdownItem>
      </>
    );
  } else if (
    profileSetupStep === "completed" &&
    subscription &&
    subscription.packageType !== constants.packageTypes.free
  ) {
    return (
      <div className="superadmin-dropdown-list">
        <div className="dropdown-group">
          <DropdownItem>
            <Link to={constants.routes.accountOwner.offices}>
              <span className="menu-hover-effect">{t("navbar.MyOffices")}</span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={constants.routes.dashboard.managerDashboard}>
              <span className="menu-hover-effect">
                {t("dashBoard.managerDashBoard")}
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link
              to={constants.routes.accountOwner.globalOfficeStaffInformation}
            >
              <span className="menu-hover-effect">
                {t("navbar.companyDirectory")}
              </span>
            </Link>
          </DropdownItem>
        </div>
        <div className="dropdown-group">
          <DropdownItem
            className={isDisabledClass.scheduler}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.scheduler.calendar,
                  state: location?.state,
                },
                !!isDisabledClass.scheduler,
              );
              setStorage("isChatFromDashBoard", false);
              setStorage("IsFromLeaveSchedule", { isFromleaveConflict: false });
              clearOfficeNavigationContext();
            }}
          >
            <div className="dropdown_padding_new">
              <span className="menu-hover-effect">{t("navbar.scheduler")}</span>
            </div>
          </DropdownItem>
          <DropdownItem
            className={isDisabledClass.liveChat}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.chatModule,
                  state: location?.state,
                },
                !!isDisabledClass.liveChat,
              );
              setStorage("isChatFromDashBoard", false);
              clearOfficeNavigationContext();
            }}
          >
            <div className="d-flex dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("messenger.teamConversation")}
              </span>
              <MessageDot type={constants.chat.teamLiveChat} />
            </div>
          </DropdownItem>
          <DropdownItem
            className={isDisabledClass.taskManagement}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.taskManagements.taskManagement,
                  state: location?.state,
                },
                !!isDisabledClass.taskManagement,
              );
              setStorage("isChatFromDashBoard", false);
              clearOfficeNavigationContext();
            }}
          >
            <div className="d-flex dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("navbar.taskManagement")}
              </span>
            </div>
          </DropdownItem>

          <DropdownItem
            className={isDisabledClass.notesAndReminder}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.notes,
                  state: location?.state,
                },
                !!isDisabledClass.notesAndReminder,
              );
              setStorage("isChatFromDashBoard", false);
              clearOfficeNavigationContext();
            }}
          >
            <div className="d-flex dropdown_padding">
              <span className="menu-hover-effect">
                <span>{t("messenger.notes")}</span>
              </span>
            </div>
          </DropdownItem>
        </div>
        <div className="dropdown-group">
          <DropdownItem
            className={isDisabledClass.taskManagement}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname:
                    constants.routes.officePolicyManagements
                      .officePolicyManagement,
                  state: location?.state,
                },
                !!isDisabledClass.taskManagement,
              );
              setStorage("isChatFromDashBoard", false);
              clearOfficeNavigationContext();
            }}
          >
            <div className="d-flex dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("navbar.officePolicyManagement")}
              </span>
            </div>
          </DropdownItem>
          <DropdownItem
            // className={isDisabledClass.scheduler}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.globalStaffList,
                  state: location?.state,
                },
                // !!isDisabledClass.scheduler
                false,
              );
            }}
          >
            <div className="dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("navbar.globalStaffList")}
              </span>
            </div>
          </DropdownItem>
        </div>
        <div className="dropdown-group">
          <DropdownItem>
            <Link to={constants.routes.staffAttendance.staffAttendance}>
              <span className="menu-hover-effect">
                {t("navbar.staffAttendance")}
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem
            className={isDisabledClass.taskManagement}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname:
                    constants.routes.credentialsAndLicensing
                      .credentialsAndLicensingGlobal,
                  state: location?.state,
                },
                false,
              );
              setStorage("isChatFromDashBoard", false);
            }}
          >
            <div className="d-flex dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("accountOwner.credentialsAndLicensing")}
              </span>
            </div>
          </DropdownItem>
        </div>
        <div className="dropdown-group">
          <DropdownItem
            className={isDisabledClass.patientAppointment}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.appointment.appointmentScreen,
                  state: location?.state,
                },
                !!isDisabledClass.patientAppointment,
              );
              setStorage("officeState", {
                officeState: { isfromPaitentDetail: true },
              });
              clearOfficeNavigationContext();
            }}
          >
            <div className="menu-hover-effect dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("navbar.patientAppointments")}
              </span>
            </div>
          </DropdownItem>

          <DropdownItem
            className={isDisabledClass.patientConversation}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.patientChatModule,
                  state: location?.state,
                },
                !!isDisabledClass.patientConversation,
              );
              setStorage("isChatFromDashBoard", false);
            }}
          >
            <div className="d-flex dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("messenger.patientConversation")}
              </span>
              <MessageDot type={constants.chat.patientChat} />
            </div>
          </DropdownItem>
        </div>
        <div className="dropdown-group">
          <DropdownItem>
            <Link to={constants.routes.accountOwner.officesList}>
              <span className="menu-hover-effect">
                {t("navbar.integrateOfficeWithPms")}
              </span>
            </Link>
          </DropdownItem>
        </div>
        <div className="dropdown-group">
          <DropdownItem>
            <Link to={constants.routes.accountOwner.profile}>
              <span className="menu-hover-effect">
                {t("navbar.viewMyProfile")}
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={constants.routes.accountPreferences}>
              <span className="menu-hover-effect">
                {t("navbar.accountSetting")}
              </span>
            </Link>
          </DropdownItem>
        </div>
        <div className="dropdown-group">
          <DropdownItem>
            <Link to={constants.routes.help}>
              <span className="menu-hover-effect">{t("navbar.help")}</span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={constants.routes.feedback}>
              <span className="menu-hover-effect">{t("navbar.feedback")}</span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={constants.routes.contact}>
              <span className="menu-hover-effect">{t("navbar.support")}</span>
            </Link>
          </DropdownItem>
          {(staffCheck || accountOwnerCheck) &&
            canAccessAiAssistantChat(userProfileData) &&
            userProfileData?.showWebAiToggleInHeader && (
              <>
                <DropdownItem>
                  <div className="d-flex dropdown_padding_new">
                    <span
                      className="menu-hover-effect"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDropdownAiChatOpen((prev) => !prev);
                        toggle();
                      }}
                    >
                      {t("aiAssistant.aiAssist")}
                    </span>
                    {dropdownAiChatOpen && (
                      <div
                        className="text-left"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <IsAccessibleChatAssitant
                          dropdownAiChatOpen={dropdownAiChatOpen}
                          setDropdownAiChatOpen={setDropdownAiChatOpen}
                        />
                      </div>
                    )}
                  </div>
                </DropdownItem>
              </>
            )}
        </div>
        <div className="dropdown-group">
          <DropdownItem>
            <Link to={constants.routes.aboutMiraxis}>
              <span className="menu-hover-effect">{t("AboutMiraxis")}</span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={constants.routes.termsAndConditions}>
              <span className="menu-hover-effect">
                {t("termsConditionsWithSymbol")}
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={constants.routes.privacyPolicy}>
              <span className="menu-hover-effect">{t("privacyPolicy")}</span>
            </Link>
          </DropdownItem>
        </div>
      </div>
    );
  } else if (
    profileSetupStep === "completed" &&
    subscription &&
    subscription.packageType === constants.packageTypes.free
  ) {
    return (
      <>
        <DropdownItem>
          <Link to={constants.routes.accountOwner.profile}>
            <span className="menu-hover-effect">{t("navbar.viewProfile")}</span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.accountOwner.managePlan}>
            <span className="menu-hover-effect">
              {t("navbar.manageSubscription")}
            </span>
          </Link>
        </DropdownItem>
      </>
    );
  } else {
    return null;
  }
}

function SuperAdminDropdownItems({ t }) {
  return (
    <div className="superadmin-dropdown-list">
      <div className="dropdown-group">
        <DropdownItem>
          <Link to="/manage-owner">
            <span className="menu-hover-effect">
              {t("navbar.manageAccountOwners")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.superAdmin.manageVendors}>
            <span className="menu-hover-effect">
              {t("navbar.manageVendors")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.superAdmin.manageSalesRepAdmin}>
            <span className="menu-hover-effect">
              {t("navbar.manageSalesRepresentatives")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to="/manage-personnel">
            <span className="menu-hover-effect">
              {t("navbar.managePersonnel")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.superAdmin.patientList}>
            <span className="menu-hover-effect">
              {t("navbar.managePatients")}
            </span>
          </Link>
        </DropdownItem>
      </div>
      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.superAdmin.broadCastMessages}>
            <span className="menu-hover-effect">
              {t("superAdmin.broadcastMessages")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to="/demo-request">
            <span className="menu-hover-effect">
              {t("navbar.demoRequests")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.superAdmin.feedback}>
            <span className="menu-hover-effect">{t("navbar.feedback")}</span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.superAdmin.SupportAndHelp}>
            <span className="menu-hover-effect">{t("navbar.support")}</span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.appVersionList}>
            <span className="menu-hover-effect">{t("navbar.appVersions")}</span>
          </Link>
        </DropdownItem>
      </div>
      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.superAdmin.reviews}>
            <span className="menu-hover-effect">
              {t("navbar.reviewsAndRatings")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to={constants.routes.superAdmin.appointmentRequestList}>
            <span className="menu-hover-effect">
              {t("navbar.appointmentRequests")}
            </span>
          </Link>
        </DropdownItem>
      </div>
      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.superAdmin.vendorSubscriptionPlans}>
            <span className="menu-hover-effect">
              {t("navbar.vendorSubscriptionPlans")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to="/subscription-management">
            <span className="menu-hover-effect">
              {t("navbar.subscriptionPlans")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to={constants.routes.accountOwner.staffRoles}>
            <span className="menu-hover-effect">
              {t("navbar.addstaffRoles")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.specialtyList}>
            <span className="menu-hover-effect">
              {t("navbar.specialtiesOrServices")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to={constants.routes.accountOwner.manageHolidays}>
            <span className="menu-hover-effect">{t("navbar.holidays")}</span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to="/manage-testimonial">
            <span className="menu-hover-effect">
              {t("navbar.manageTestimonials")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to="/manage-content">
            <span className="menu-hover-effect">
              {t("navbar.manageContent")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.superAdmin.TopUpPromotions}>
            <span className="menu-hover-effect">{t("navbar.manageTopUp")}</span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to={constants.routes.superAdmin.categories}>
            <span className="menu-hover-effect">
              {t("navbar.manageCategories")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to={constants.routes.superAdmin.tax}>
            <span className="menu-hover-effect">
              {t("navbar.taxManagement")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to={constants.routes.superAdmin.manageCommissions}>
            <span className="menu-hover-effect">
              {t("navbar.manageCommissions")}
            </span>
          </Link>
        </DropdownItem>
      </div>
      <div className="dropdown-group">
        <DropdownItem>
          <Link to="/ai-settings">
            <span className="menu-hover-effect">{t("navbar.AISettings")}</span>
          </Link>
        </DropdownItem>
      </div>
      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.editProfile}>
            <span className="menu-hover-effect">
              {t("navbar.viewMyProfile")}
            </span>
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to="/change-password">
            <span className="menu-hover-effect">
              {t("navbar.changePassword")}
            </span>
          </Link>
        </DropdownItem>
      </div>
    </div>
  );
}

function StaffDropdownItems({
  t,
  profile,
  ownerList,
  isDisabledClass,
  redirectWithCheck,
  location,
  accountOwnerCheck,
  staffCheck,
  userProfileData,
  dropdownAiChatOpen,
  setDropdownAiChatOpen,
  toggle,
  setIsAdminModalOpen,
  newNotification,
}) {
  const {
    isAdmin,
    isMessenger,
    isDoctor,
    isStaffCreatedBySignUp,
    isPatientChat,
  } = profile;
  const isOwnerListHasData = !!(ownerList && ownerList.length);

  return (
    <div className="superadmin-dropdown-list">
      {ownerList?.length > 0 && (
        <div className="dropdown-group">
          <DropdownItem>
            <span
              className="menu-hover-effect"
              onClick={() => {
                setIsAdminModalOpen((prev) => !prev);
              }}
            >
              {t("staff.switchOwner")}
            </span>
          </DropdownItem>
        </div>
      )}
      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.staff.offices}>
            <span className="menu-hover-effect">{t("navbar.MyOffices")}</span>
          </Link>
        </DropdownItem>
        {!isAdmin && isOwnerListHasData && (
          <DropdownItem>
            <Link to={constants.routes.dashboard.managerDashboard}>
              <span className="menu-hover-effect">
                {t("dashBoard.teamDashboard")}
              </span>
            </Link>
          </DropdownItem>
        )}
        {isAdmin && isOwnerListHasData && (
          <DropdownItem>
            <Link to={constants.routes.dashboard.managerDashboard}>
              <span className="menu-hover-effect">
                {t("dashBoard.managerDashBoard")}
              </span>
            </Link>
          </DropdownItem>
        )}
        {isOwnerListHasData && (
          <DropdownItem>
            <Link
              to={constants.routes.accountOwner.globalOfficeStaffInformation}
            >
              <span className="menu-hover-effect">
                {t("navbar.companyDirectory")}
              </span>
            </Link>
          </DropdownItem>
        )}
      </div>
      <div className="dropdown-group">
        {isOwnerListHasData && (
          <DropdownItem
            className={isDisabledClass.scheduler}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.scheduler.calendar,
                  state: location?.state,
                },
                !!isDisabledClass.scheduler,
              );
              setStorage("isChatFromDashBoard", false);
              setStorage("IsFromLeaveSchedule", { isFromleaveConflict: false });
              clearOfficeNavigationContext();
            }}
          >
            <span className="menu-hover-effect">{t("navbar.scheduler")}</span>
          </DropdownItem>
        )}

        {(isAdmin || !!isMessenger) && (
          <DropdownItem
            className={isDisabledClass.liveChat}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.chatModule,
                  state: location?.state,
                },
                !!isDisabledClass.liveChat,
              );
              setStorage("isChatFromDashBoard", false);
              clearOfficeNavigationContext();
            }}
          >
            <div className="d-flex dropdown_padding">
              <span className="menu-hover-effect">
                {t("messenger.teamConversation")}
              </span>
              <MessageDot type={constants.chat.teamLiveChat} />
            </div>
          </DropdownItem>
        )}

        {isOwnerListHasData && (
          <DropdownItem
            className={isDisabledClass.taskManagement}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.taskManagements.taskManagement,
                  state: location?.state,
                },
                !!isDisabledClass.taskManagement,
              );
              setStorage("isChatFromDashBoard", false);
              clearOfficeNavigationContext();
            }}
          >
            <div className="d-flex dropdown_padding">
              <span className="menu-hover-effect">
                {t("navbar.taskManagement")}
              </span>
            </div>
          </DropdownItem>
        )}

        <DropdownItem
          className={isDisabledClass.notesAndReminder}
          onClick={() => {
            redirectWithCheck(
              {
                pathname: constants.routes.notes,
                state: location?.state,
              },
              !!isDisabledClass.notesAndReminder,
            );
            setStorage("isChatFromDashBoard", false);
            clearOfficeNavigationContext();
          }}
        >
          <div className="d-flex dropdown_padding">
            <span className="menu-hover-effect">
              <span>{t("messenger.notes")}</span>
            </span>
          </div>
        </DropdownItem>
      </div>
      {isOwnerListHasData && (
        <div className="dropdown-group">
          <DropdownItem
            onClick={() => {
              redirectWithCheck({
                pathname:
                  constants.routes.officePolicyManagements
                    .officePolicyManagement,
                state: location?.state,
              });
              setStorage("isChatFromDashBoard", false);
              clearOfficeNavigationContext();
            }}
          >
            <div className="d-flex dropdown_padding_new">
              <span className="menu-hover-effect">
                {t("navbar.officePolicyManagement")}
              </span>
            </div>
          </DropdownItem>
          {isAdmin && (
            <DropdownItem
              // className={isDisabledClass.scheduler}
              onClick={() => {
                redirectWithCheck(
                  {
                    pathname: constants.routes.globalStaffList,
                    state: location?.state,
                  },
                  // !!isDisabledClass.scheduler
                  false,
                );
              }}
            >
              <div className="dropdown_padding_new">
                <span className="menu-hover-effect">
                  {t("navbar.globalStaffList")}
                </span>
              </div>
            </DropdownItem>
          )}
        </div>
      )}
      {isAdmin && isOwnerListHasData && (
        <div className="dropdown-group">
          <DropdownItem>
            <Link to={constants.routes.staffAttendance.staffAttendance}>
              <span className="menu-hover-effect">
                {t("navbar.staffAttendance")}
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem className={isDisabledClass.taskManagement}>
            <Link
              to={
                constants.routes.credentialsAndLicensing
                  .credentialsAndLicensingGlobal
              }
            >
              <span className="menu-hover-effect">
                {t("accountOwner.credentialsAndLicensing")}
              </span>
            </Link>
          </DropdownItem>
        </div>
      )}

      <div className="dropdown-group">
        {isDoctor && (
          <DropdownItem
            className={isDisabledClass.patientAppointment}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.appointment.appointmentScreen,
                  state: location?.state,
                },
                !!isDisabledClass.patientAppointment,
              );
              setStorage("officeState", {
                officeState: { isfromPaitentDetail: true },
              });
            }}
          >
            <div className="d-flex dropdown_padding">
              <span className="menu-hover-effect">
                {t("navbar.patientAppointments")}
              </span>
            </div>
          </DropdownItem>
        )}

        {!!isPatientChat && (
          <DropdownItem
            className={isDisabledClass.patientConversation}
            onClick={() => {
              redirectWithCheck(
                {
                  pathname: constants.routes.patientChatModule,
                  state: location?.state,
                },
                !!isDisabledClass.patientConversation,
              );
              setStorage("isChatFromDashBoard", false);
            }}
          >
            <div className="d-flex dropdown_padding">
              <span className="menu-hover-effect">
                {t("messenger.patientConversation")}
              </span>
              <MessageDot type={constants.chat.patientChat} />
            </div>
          </DropdownItem>
        )}
      </div>

      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.viewProfile}>
            <span className="menu-hover-effect">{t("navbar.myProfile")}</span>
          </Link>
        </DropdownItem>
        {!isStaffCreatedBySignUp && (
          <DropdownItem>
            <Link to={constants.routes.accountPreferences}>
              <span className="menu-hover-effect">
                {t("navbar.accountSetting")}
              </span>
            </Link>
          </DropdownItem>
        )}
      </div>

      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.help}>
            <span className="menu-hover-effect">{t("navbar.help")}</span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.feedback}>
            <span className="menu-hover-effect">{t("navbar.feedback")}</span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.contact}>
            <span className="menu-hover-effect">{t("navbar.support")}</span>
          </Link>
        </DropdownItem>
        {(staffCheck || accountOwnerCheck) &&
          canAccessAiAssistantChat(userProfileData) &&
          userProfileData?.showWebAiToggleInHeader && (
            <>
              <DropdownItem>
                <div className="d-flex dropdown_padding_new">
                  <span
                    className="menu-hover-effect"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdownAiChatOpen((prev) => !prev);
                      toggle();
                    }}
                  >
                    {t("aiAssistant.aiAssist")}
                  </span>
                  {dropdownAiChatOpen && (
                    <div
                      className="text-left"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <IsAccessibleChatAssitant
                        dropdownAiChatOpen={dropdownAiChatOpen}
                        setDropdownAiChatOpen={setDropdownAiChatOpen}
                      />
                    </div>
                  )}
                </div>
              </DropdownItem>
            </>
          )}
      </div>
      <div className="dropdown-group">
        <DropdownItem>
          <Link to={constants.routes.aboutMiraxis}>
            <span className="menu-hover-effect">{t("AboutMiraxis")}</span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.termsAndConditions}>
            <span className="menu-hover-effect">
              {t("termsConditionsWithSymbol")}
            </span>
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to={constants.routes.privacyPolicy}>
            <span className="menu-hover-effect">{t("privacyPolicy")}</span>
          </Link>
        </DropdownItem>
      </div>
    </div>
  );
}

function PatientDropdownItems({ t }) {
  return (
    <>
      <DropdownItem>
        <Link to={constants.routes.doctors}>
          <span className="menu-hover-effect">{t("doctors")}</span>
        </Link>
      </DropdownItem>
      <DropdownItem>
        <Link to={constants.routes.familyMembers}>
          <span className="menu-hover-effect">{t("navbar.familyMembers")}</span>
        </Link>
      </DropdownItem>
      <DropdownItem>
        <Link to={constants.routes.patientWithOwnerOrDoctorChatModule}>
          <span className="menu-hover-effect">{t("navbar.doctorChat")}</span>
          <MessageDot type={constants.chat.patientChat} />
        </Link>
      </DropdownItem>
      <DropdownItem>
        <Link to={constants.routes.help}>
          <span className="menu-hover-effect">{t("navbar.help")}</span>
        </Link>
      </DropdownItem>
      <DropdownItem>
        <Link to={constants.routes.feedback}>
          <span className="menu-hover-effect">{t("navbar.feedback")}</span>
        </Link>
      </DropdownItem>
    </>
  );
}

const mapStateToProps = ({ userProfile: { profile } }) => ({
  profile,
});
export default connect(
  mapStateToProps,
  null,
)(withTranslation()(HeaderDropdown));
